import React from "react";
import { CalendarDays } from "lucide-react";
import { Calender } from "./icons";

const DashboardSessions = ({ title, description, time }) => {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-[#00A53D] bg-[linear-gradient(90deg,_#C8EAD41C_0%,_#DCFCE71C_100%)] p-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:p-5">
      <div className="flex min-w-0 items-start gap-3 sm:items-center sm:gap-6">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#4DE083]">
          <Calender />
        </div>

        <div className="min-w-0">
          <h3 className="text-base font-semibold text-[#166534] sm:text-lg">
            {title}
          </h3>

          <p className="break-words text-sm text-[#16A34A] sm:text-base">
            {description}
          </p>

          <p className="mt-1 break-words text-sm text-[#16A34A]">{time}</p>
        </div>
      </div>

      <button
        type="button"
        className="w-full shrink-0 rounded-lg bg-[#16A34A] px-4 py-2 text-base text-white transition-colors hover:bg-[#15803D] sm:mr-0 sm:w-auto lg:mr-14"
      >
        View Details
      </button>
    </div>
  );
};

export default DashboardSessions;
